import React from 'react';

import { NewRelicBrowserAgentProvider } from '@notino/react-observability';

import { useApplicationBuildContext } from '@context/ApplicationBuildContext';
import { ReactFCC } from '@types';

export const NewRelicProvider: ReactFCC = ({ children }) => {
  const {
    settings: { newRelicLicenseKey, newRelicAccountId, newRelicAppId, environment, applicationName },
  } = useApplicationBuildContext();

  return (
    <NewRelicBrowserAgentProvider
      licenseKey={newRelicLicenseKey}
      applicationID={newRelicAppId}
      accountID={newRelicAccountId}
      appVersion={applicationName}
      environment={environment}>
      {children}
    </NewRelicBrowserAgentProvider>
  );
};
